import { render, staticRenderFns } from "./RbuFluctuation.vue?vue&type=template&id=f35cf976"
import script from "./RbuFluctuation.vue?vue&type=script&lang=js"
export * from "./RbuFluctuation.vue?vue&type=script&lang=js"
import style0 from "./RbuFluctuation.vue?vue&type=style&index=0&id=f35cf976&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports